import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { listJobs, updateJob, type JobOut } from "@/lib/api/jobs";

/** 처리 중인 Job 이 하나라도 있으면 자동 폴링 — 완료되면 정지.
 *  cancelling 은 중지 마감(cancelled)까지 상태가 더 바뀌므로 폴링 유지. */
const ACTIVE_STATUSES = new Set(["pending", "processing", "cancelling"]);

export const JOBS_QUERY_KEY = ["jobs"] as const;

export function useJobs() {
  return useQuery<JobOut[]>({
    queryKey: JOBS_QUERY_KEY,
    queryFn: listJobs,
    refetchInterval: (query) => {
      const data = query.state.data;
      if (!data) return 5000;
      const hasActive = data.some((j) => ACTIVE_STATUSES.has(j.status));
      return hasActive ? 3000 : false;
    },
  });
}

/** Job 배치명(제목) 수정 — 성공 시 목록 캐시 무효화. */
export function useUpdateJob() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ jobId, batchName }: { jobId: string; batchName: string | null }) =>
      updateJob(jobId, batchName),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: JOBS_QUERY_KEY });
    },
  });
}
